import { render, staticRenderFns } from "./ViewPropertyComponent.vue?vue&type=template&id=92544214"
import script from "./ViewPropertyComponent.vue?vue&type=script&lang=js"
export * from "./ViewPropertyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports